/**
 * SSR で実行するクエリの first に渡す値の定数
 */
export const SERVER_FETCH_COUNT = {
  SHELVES_BY_VOD_TOP: 10,
  SHELVES_BY_CATEGORY_TOP: 100,
  ITEMS_BY_NOTIFICATIONS: 100,
  /**
   * NOTE: SEO部の方と調整した数字
   * 昔のアニメでだと全51話のように50話弱のものが多いので、
   * 60件であれば概ねカバーできるのでは、という前提の数字
   */
  EPISODES_BY_VOD_DETAIL: 60,
  /**
   * NOTE: SEO部の方と調整した数字
   * レビューはそんなにつかないので、20件あれば問題ない
   */
  REVIEW_BY_VOD_DETAIL: 20,
  PREVIEW_BY_VOD_DETAIL: 10,
  SHELF_BY_FEATURE: 50,
  ITEMS_BY_FEATURE: 100,
  ITEMS_BY_RANKING: 100,
} as const;
